import { useMemo } from 'react'

import { useQuery } from 'react-query'

import { expenseReportQueryConfig } from '../../../query-configs/expenseReport'

export const useQuerySpendBySecondaryCategory = ({
  expenseUuid,
  secondaryCategoryId,
  expenseId,
  enabled,
  startDate,
  endDate,
}: {
  expenseUuid: uuid
  secondaryCategoryId: number | undefined
  expenseId: number | undefined
  enabled: boolean
  startDate: ISODateString
  endDate: ISODateString
}) => {
  const { data, isLoading } = useQuery({
    ...expenseReportQueryConfig.getSpendBySecondaryCategory({
      expenseUuid,
      expenseId,
      secondaryCategoryId,
      startDate,
      endDate,
    }),
    enabled:
      enabled &&
      !!secondaryCategoryId &&
      !!expenseId &&
      !!startDate &&
      !!endDate,
  })

  const secondaryCategorySpend = useMemo(() => {
    if (!data)
      return { budgetCategories: undefined, uncategorizedSpend: undefined }

    const {
      data: {
        approved,
        currentRequestPending,
        invoiced,
        pending,
        purchased,
        received,
      },
    } = data
    return {
      approvedSpend: approved,
      currentRequestPendingSpend: currentRequestPending,
      invoicedSpend: invoiced,
      pendingSpend: pending,
      purchasedSpend: purchased,
      receivedSpend: received,
    }
  }, [data])

  return { secondaryCategorySpend, isLoading }
}
